import React from 'react'
import { useSelector } from 'react-redux'
import GameView from './components/game-view'
import { getGrid, getPlayers } from './gameSlice'

export default function WatchGameContainer() {
    const players = useSelector(getPlayers)
    const grid = useSelector(getGrid)
    
    return (
        <GameView
            players={players}
            grid={grid}
        />
    )
}